import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Container } from 'styled-bootstrap-grid'

import theme from 'ui/styles/theme'
import getRelativeUrl from 'utils/getRelativeUrl'

import IconCapacitive from 'ui/components/generic/IconCapacitive'
import IconClimate from 'ui/components/generic/IconClimate'
import IconProduction from 'ui/components/generic/IconProduction'


const SubMenuItemLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 150px;
  width: 100%;

  background-color: ${props => props.theme.colors.tones.lightest};
  cursor: pointer;

  transition: all 400ms;

  span {
    display: inline-block;
    margin-top: 15px;

    color: ${props => props.theme.colors.primary};
    font-size: 12px;
  }

  &&&:hover {
    background-color: ${props => props.theme.colors.primary};

    span {
      color: #fff;
    }
  }
`

const SubMenuItem = styled.div`
  display: flex;
  flex: 1;

  transform: translateY(-50%);
  transition: all 600ms;
  transition-delay: ${props => props.delay}ms;

  &:nth-child(even) {
    ${SubMenuItemLink} {
      background-color: ${props => props.theme.colors.tones.lighter};
    }
  }
`

const SubMenuItems = styled.div`
  display: flex;
`

const Wrapper = styled.div`
  position: absolute;
  top: ${props => props.theme.navHeight}px;
  left: 0px;
  width: 100%;
  height: 150px;
  z-index: 0;

  background-color: #fff;

  transform: translateY(${props => props.visible ? 0 : -150}px);
  opacity: ${props => props.visible ? 1 : 0};
  transition: all 1000ms;
  transition-delay: ${props => props.visible ? 200 : 0}ms;

  ${SubMenuItem} {
    transform: translateY(${props => props.visible ? 0 : -50}%);
    opacity: ${props => props.visible ? 1 : 0};
  }
`

class SubMenu extends Component {
  state = {
    hover: false,
    hasIcons: false
  }

  getDelay(index) {
    return 600 + (index * 200)
  }

  getIcon(icon, white) {
    const colors = {
      color1: white ? '#fff' : theme.colors.primary,
      color2: white ? '#fff' : theme.colors.secondary,
    }

    switch (icon) {
      case 'capacitive':
        return <IconCapacitive {...colors} />
      case 'climate':
        return <IconClimate {...colors} />
      case 'production':
        return <IconProduction {...colors} />
      default:
        return null
    }
  }

  render() {
    const {
      visible,
      items,
      onMouseEnter,
      onMouseLeave,
      onClickLink
    } = this.props

    const { hover } = this.state

    return (
      <Wrapper
        visible={visible}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Container fluid>
          <SubMenuItems>
            {items && items.map((item, index) => (
              <SubMenuItem
                key={item.id}
                delay={this.getDelay(index)}
                onMouseEnter={() => this.setState({ hover: item.id })}
                onMouseLeave={() => this.setState({ hover: undefined })}
              >
                <SubMenuItemLink
                  to={getRelativeUrl(item.url)}
                  onClick={onClickLink}
                >
                  {this.getIcon(item.icon, hover === item.id)}
                  <span>{item.label}</span>
                </SubMenuItemLink>
              </SubMenuItem>
            ))}
          </SubMenuItems>
        </Container>
      </Wrapper>
    );
  }
}

export default SubMenu



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/SubMenu.js